import { render, staticRenderFns } from "./BadgeDeleted.vue?vue&type=template&id=08a12d19&scoped=true&"
import script from "./BadgeDeleted.vue?vue&type=script&lang=js&"
export * from "./BadgeDeleted.vue?vue&type=script&lang=js&"
import style0 from "./BadgeDeleted.vue?vue&type=style&index=0&id=08a12d19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a12d19",
  null
  
)

export default component.exports